/**
 * Transforme la réponse de GET /hr/pilotage/temps-travail en modèle
 * consommé par TempsSection.
 */
export const mapTempsTravail = (api) => ({
    pctRealise: api.realized_hours_pct ?? 0,
    pctRealisePrevious: api.realized_hours_pct_previous ?? null,
    ecartTheorique: api.theoretical_hours_gap ?? 0,
    ecartTheoriquePrevious: api.theoretical_hours_gap_previous ?? null,
    heuresSup: api.overtime_hours ?? 0,
    heuresSupPrevious: api.overtime_hours_previous ?? null,
    telePct: api.remote_work_pct ?? 0,
    telePctPrevious: api.remote_work_pct_previous ?? null,
    presentielPct: api.onsite_work_pct ?? 0,
    presentielPctPrevious: api.onsite_work_pct_previous ?? null,
    teleJours: api.average_remote_days ?? 0,
    teleJoursPrevious: api.average_remote_days_previous ?? null,
});
